import React from "react";
import { ListItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

const SidebarItem = ({
    icon,
    label,
    isActive,
    isCollapsed,
    onClick,
    href,
    target,
    rel,
    component = "div",
}) => {
    const linkProps = href
        ? { component: Link, to: href, target, rel }
        : { component: component, href, target, rel };
    const content = (
        <ListItem
            button
            {...linkProps}
            onClick={onClick}
            sx={{
                borderRadius: 1.5,
                mx: 1,
                my: 0.25,
                py: 1.25,
                px: isCollapsed ? 1.5 : 2,
                display: "flex",
                alignItems: "center",
                justifyContent: isCollapsed ? "center" : "flex-start",
                backgroundColor: isActive ? "rgba(255,255,255,0.15)" : "transparent",
                "&:hover": {
                    backgroundColor: isActive ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.08)",
                },
                transition: "all 0.2s ease",
                textDecoration: "none",
                color: "white",
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: isCollapsed ? 0 : 40,
                    color: "inherit",
                    justifyContent: "center",
                }}
            >
                {icon}
            </ListItemIcon>
            {!isCollapsed && (
                <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                        fontSize: "0.8125rem",
                        fontWeight: isActive ? 600 : 500,
                    }}
                    sx={{ opacity: 1, ml: 0 }}
                />
            )}
        </ListItem>
    );

    if (isCollapsed && label) {
        return (
            <Tooltip title={label} placement="right" arrow>
                {content}
            </Tooltip>
        );
    }
    return content;
};

export default SidebarItem;
